// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EmailReturnResultResponse {
    static getAttributeTypeMap() {
        return EmailReturnResultResponse.attributeTypeMap;
    }
}
EmailReturnResultResponse.discriminator = undefined;
EmailReturnResultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EmailReturnResult"
    }
];
//# sourceMappingURL=emailReturnResultResponse.js.map